// ----------------------------------------------------------------------
// <copyright file="Izenda.DropDownList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Drop Down List component
 */
!(function() {
  var React = require('react');
  var classnames = require('classnames');

  var observer = require('mobx-react').observer;
  const { get, isString, isFunction, uniqueId, keys, isNil, find, groupBy } = require('lodash/fp');
  var HIDDEN_SELECTED_VALUE = '***HIDDEN VALUE***';

  var DropDownList = React.createClass({
    propTypes: {
      id: React.PropTypes.string,
      options: React.PropTypes.oneOfType([React.PropTypes.object.isRequired, React.PropTypes.array.isRequired]),
      value: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
      maskedHidden: React.PropTypes.bool,
      valueField: React.PropTypes.oneOfType([React.PropTypes.func, React.PropTypes.string]),
      labelField: React.PropTypes.oneOfType([React.PropTypes.func, React.PropTypes.string]),
      onChange: React.PropTypes.func,
      groupBy: React.PropTypes.oneOfType([React.PropTypes.func, React.PropTypes.string]),
      groupFormatText: React.PropTypes.func,
      blankOption: React.PropTypes.bool,
      getOptionProperties: React.PropTypes.func,
      buildGroupLabel: React.PropTypes.func,
      optionTooltip: React.PropTypes.string,
      additionalKey: React.PropTypes.string
    },

    /**
     * Get default props
     */
    getDefaultProps: function() {
      return {
        value: null,
        maskedHidden: false,
        valueField: 'value',
        labelField: 'label',
        onChange: null,
        disabled: false,
        blankOption: false,
        blankOptionText: ''
      };
    },

    /**
     * Get initial state
     */
    getInitialState: function() {
      return {
        selected: this.props.value,
        hiddenSelected: this.props.maskedHidden
      };
    },

    /**
     * Component will receive props
     */
    componentWillReceiveProps: function(nextProps) {
      this.setState({
        selected: nextProps.value,
        hiddenSelected: nextProps.maskedHidden
      });
    },

    getValue: function(valueField, option) {
      if (isString(valueField)) {
        return get(valueField, option);
      } else if (isFunction(valueField)) {
        return valueField(option);
      }
    },

    renderListOption: function(options) {
      var props = this.props;
      var getValue = this.getValue;
      options = options || [];

      return options.map(function(option, index) {
        var value = props.valueField ? getValue(props.valueField, option) : option;
        var key = props.additionalKey ? value + props.additionalKey : value;

        var label = props.labelField ? getLabel(props.labelField, option) : option;
        var additionOptionProps = props.getOptionProperties && props.getOptionProperties(option);
        var tooltip = props.showTooltip ? option[props.optionTooltip] || label : null;

        return (
          <option key={key + index} value={value} {...additionOptionProps} title={tooltip}>
            {label}
          </option>
        );
      });

      function getLabel(labelField, option) {
        if (isString(labelField)) {
          return get(labelField, option);
        } else if (isFunction(labelField)) {
          return labelField(option);
        }
      }
    },

    /**
     * Render component
     * @returns {Object}
     */
    render: function() {
      var state = this.state;
      var props = this.props;
      var disabledAttr = props.disabled ? 'disabled' : null;
      var classes = classnames(this.props.className, 'form-control');
      var options = this.renderListOption(props.options);

      if (props.groupBy) {
        var optionsGrouped =
          groupBy(function(option) {
            return isFunction(props.groupBy) ? props.groupBy(option) : option[props.groupBy];
          }, props.options) || {};
        options = keys(optionsGrouped).map(
          function(name) {
            var groupValue = optionsGrouped[name];
            var group = this.renderListOption(groupValue);
            var title = props.groupFormatText ? props.groupFormatText(groupValue[0]) : '';
            var label = props.buildGroupLabel ? props.buildGroupLabel(groupValue[0]) : name;
            return (
              <optgroup key={name} label={label} title={title}>
                {group}
              </optgroup>
            );
          }.bind(this)
        );
      }

      props.blankOption &&
        options.unshift(
          <option key={uniqueId('blankOption_')} value="" disabled={props.disabledBlankOption}>
            {props.blankOptionText}
          </option>
        );

      state.hiddenSelected &&
        options.push(
          <option key={uniqueId('hide_')} className="hide" value={HIDDEN_SELECTED_VALUE}>
            ●●●●●●●●●●●●
          </option>
        );

      var selectedValue = state.hiddenSelected
        ? HIDDEN_SELECTED_VALUE
        : !isNil(state.selected)
          ? state.selected
          : props.defaultValue;
      var selectedOption = find({ value: selectedValue }, props.options);
      var selectTooltip = selectedOption && selectedOption[props.labelField];

      return (
        <select
          ref="selectCtrl"
          id={this.props.id}
          title={props.showTooltip ? selectTooltip : null}
          className={classes}
          value={selectedValue}
          onChange={this.handleChange}
          disabled={disabledAttr}
          onFocus={props.onFocus}
        >
          {options}
        </select>
      );
    },

    componentDidUpdate: function() {
      var selectedValue = !isNil(this.state.selected) ? this.state.selected : '';
      var selectCtrl = this.refs.selectCtrl;

      // sync value of control and component state
      if (!selectedValue && selectCtrl.value !== selectedValue) {
        selectCtrl.value = selectedValue;
      }
    },

    /**
     * Handle change
     */
    handleChange: function(e) {
      var oldValue = this.state.selected;
      var value = e.target.value;
      var getValue = this.getValue;

      this.setState({
        selected: value,
        hiddenSelected: false
      });
      if (this.props.onChange) {
        var valueField = this.props.valueField;
        var labelField = this.props.labelField;
        var selectedItem = find(function(option) {
          return value == getValue(valueField, option);
        }, this.props.options);
        var change = {
          value: e.target.value,
          label: get(labelField, selectedItem)
        };
        Promise.resolve(this.props.onChange(change, selectedItem)).catch(
          function() {
            // revert to old value if the promise is reject
            this.setState({ selected: oldValue });
          }.bind(this)
        );
      }
    }
  });

  module.exports = observer(DropDownList);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.DropDownList.jsx